









import {
  computed,
  defineComponent,
} from '@vue/composition-api';
import { getValidCSSUnit } from '~/constants/helpers';
import {
  TColorKeys,
  colors,
} from '~/types/fightcamp';
import { componentWhiteList } from './helpers';
import { IPageSectionContentAttrs } from './types';

export default defineComponent({
  name: 'PageSectionContent',
  inheritAttrs: false,
  setup(_, context) {
    const {
      minWidth,
      content,
      backgroundColor = 'transparent',
      flexRatio = null,
    } = context.attrs as IPageSectionContentAttrs;

    const getFlexValue = () => {
      switch (flexRatio) {
      case 'half':
        return '0 0 50%';
      case 'third':
        return '0 0 33.333%';
      default:
        return '1';
      }
    };

    return {
      styles: computed(() => ({
        minWidth: getValidCSSUnit(minWidth, ''),
        backgroundColor: colors[backgroundColor as TColorKeys],
        flex: getFlexValue(),
      })),
      content: computed(() => (content ?? [])
        .filter(({ component }) => componentWhiteList.has(component))
        .find(c => c)),
    };
  },
});
